import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CHECKOUT_URL, IMAGES, OFFER_INCLUDES, TRUST_LINE } from '../data/content';
export function Pricing() {
  return <section id="pricing" className="relative scroll-mt-2 overflow-hidden border-y border-gold/20 bg-ink py-10 sm:py-14" aria-labelledby="pricing-title" data-id="element-106" data-mp="2ohnyq31rd2l1">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-1/2" style={{
      background: 'radial-gradient(70% 100% at 50% 0%, rgba(197,163,92,0.12) 0%, rgba(20,20,22,0) 100%)'
    }} aria-hidden="true" data-id="element-107" data-mp="1vtiah6bhwvgg" />

      <div className="relative mx-auto max-w-5xl px-4 sm:px-6 lg:px-8" data-id="element-108" data-mp="25pv4k5aydbbq">
        <div className="text-center" data-id="element-109" data-mp="20rjw9z0b38vm">
          <p className="inline-flex rounded-full border border-gold/40 bg-gold/[0.08] px-3 py-1 text-[9.5px] font-bold uppercase tracking-[0.22em] text-gold sm:text-[11px]" data-id="element-110" data-mp="3h7ecuc3e44h5">
            Special Launch Offer
          </p>
          <h2 id="pricing-title" className="mt-3 font-display text-[28px] font-bold uppercase leading-[1] tracking-tight text-cream sm:text-[38px] lg:text-[46px]" data-id="element-111" data-mp="3vzyowms43j5q">
            Get The Complete{' '}
            <span className="text-gold" data-id="element-112" data-mp="9ss0jr98iy9h">Functional Coach System™</span>
          </h2>
        </div>

        <div className="mt-6 grid gap-6 lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-10" data-id="element-113" data-mp="eqti27r0ipiu">
          {/* Product — second and final major appearance */}
          <div className="relative" data-id="element-114" data-mp="3i7iq5y68u7am">
            <div className="pointer-events-none absolute left-1/2 top-1/2 h-[80%] w-[110%] -translate-x-1/2 -translate-y-1/2 rounded-full" style={{
            background: 'radial-gradient(closest-side, rgba(58,55,48,0.95) 0%, rgba(28,27,26,0.55) 48%, rgba(20,20,22,0) 78%)'
          }} aria-hidden="true" data-id="element-115" data-mp="3i8k2e5yzwztx" />
            <img src={IMAGES.productBundle} alt="Everything included in the Functional Coach System: six core modules, five bonuses, planners and digital coaching tools" className="relative mx-auto w-[95%] max-w-[520px] drop-shadow-[0_26px_40px_rgba(0,0,0,0.7)] lg:w-full lg:max-w-none" width={1500} height={1000} data-id="element-116" data-mp="2zg9gnowh3ij1" />
          </div>

          <div data-id="element-117" data-mp="2w83a2caudlry">
            <h3 className="text-center font-display text-[15px] font-bold uppercase tracking-[0.16em] text-gold lg:text-left" data-id="element-118" data-mp="2w9o480t8v2pa">
              Everything You Get Today
            </h3>
            <ul className="mt-3 grid grid-cols-2 gap-x-3 gap-y-2 lg:grid-cols-1 lg:gap-y-1.5" data-id="element-119" data-mp="23kgz2izabev2">
              {OFFER_INCLUDES.map(item => <li key={item} className="flex items-start gap-1.5" data-id="element-120" data-mp="2dhd7kop6o0zm">
                  <CheckIcon className="mt-[3px] h-3.5 w-3.5 shrink-0 text-gold" aria-hidden="true" data-id="element-121" data-mp="2dj6hccv3f1bu" />
                  <span className="text-[12px] font-medium leading-snug text-cream sm:text-[14px]" data-id="element-122" data-mp="3ov7a02v2v9wv">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-5 rounded-lg border border-gold/30 bg-charcoal p-4 text-center sm:p-5" data-id="element-123" data-mp="5a9pcqrrrmz3">
              <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-mutedtext sm:text-[11px]" data-id="element-124" data-mp="3ngejxkzi0o0r">
                Reference Value:{' '}
                <span className="line-through decoration-gold/70 decoration-2" data-id="element-125" data-mp="j151qd1h8m7f">
                  $97 USD
                </span>
              </p>
              <p className="mt-1.5 text-[10px] font-bold uppercase tracking-[0.22em] text-gold sm:text-[11px]" data-id="element-126" data-mp="nyn3njh2u15x">
                Special Launch Price
              </p>
              <p className="font-display text-[80px] font-bold leading-[0.82] tracking-tight text-cream sm:text-[96px]" data-id="element-127" data-mp="e9myfibze9ja">
                $19
                <span className="ml-1.5 align-top font-display text-base font-semibold tracking-[0.12em] text-mutedtext sm:text-lg" data-id="element-128" data-mp="11y65jujaog9s">
                  USD
                </span>
              </p>
              <p className="mt-2 text-[12.5px] font-medium text-mutedtext sm:text-sm" data-id="element-129" data-mp="3f93dxu3zv9kb">
                Pay once. Get immediate digital access.
              </p>

              <div className="mt-4" data-id="element-130" data-mp="358t14alvg45o">
                <CtaButton href={CHECKOUT_URL} external data-id="element-131" data-mp="359ump90ik91n">
                  🚀 Yes, I Want The Complete System — $19
                </CtaButton>
                <p className="mt-2.5 flex flex-wrap items-center justify-center gap-1.5 text-center text-[10px] font-medium uppercase tracking-[0.12em] text-mutedtext sm:text-[11px]" data-id="element-132" data-mp="1scidbjy9k5z">
                  <LockIcon className="h-3 w-3 text-gold" aria-hidden="true" data-id="element-133" data-mp="3t19l4qp6667m" />
                  {TRUST_LINE}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}